import React, { useRef, useEffect } from 'react'
import classes from './Contact.module.css'
import { animated, useSpring, useChain, config, useSpringRef } from 'react-spring'

const Contact = () => {
  //springs and refs
  const l1ref = useSpringRef()
  const l2ref = useSpringRef()
  const l3ref = useSpringRef()
  const l4ref = useSpringRef()
  const l5ref = useSpringRef()

  const l1Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l1ref,
  })
  const l2Spring = useSpring({
    from: { transform: 'translateX(-50px)', opacity: 0 },
    to: { transform: 'translateX(0px)', opacity: 1 },
    ref: l2ref,
  })
  const l3Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l3ref,
  })
  const l4Spring = useSpring({
    from: { transform: 'translateY(100px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l4ref,
  })
  const l5Spring = useSpring({
    from: { transform: 'translateY(100px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l5ref,
  })

  //spring for browithphone svg
  const [broSpring, setBroSpring] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 10, tension: 550, friction: 140 },
  }))
  //calculate distance from center of the scren
  const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
  //translations for individual elements
  const transMessage = (x, y) => `translate3d(${-(x + y) / 10}px,0,0)`
  const transMessage1 = (x, y) => `translate3d(${(x + y) / 10}px,0,0)`
  const transBro = (x, y) => `translate3d(${(x + y) / 8}px,0,0)`

  //interval for random animation of webdev
  const broTimer = useRef({
    timer: null,
  })

  useEffect(_ => {
    broTimer.current.timer = setInterval(() => {
      let x = Math.floor(Math.random() * 50)
      let y = Math.floor(Math.random() * 100)
      setBroSpring({ xy: [x, y] })
    }, 500)
  })

  useChain([l1ref, l2ref, l3ref, l4ref, l5ref], [0, 0.2, 0.4, 0.6, 0.8])

  return (
    <div className={classes.container}>
      <div>
        <animated.h1 className={classes.header} style={l1Spring}>
          Let's{' '}
          <animated.span style={l2Spring} className={classes.green}>
            talk
          </animated.span>
        </animated.h1>
        <animated.p className={classes.subhead} style={l3Spring}>
          You can find me on following
        </animated.p>
        <animated.div className={classes.social} style={l4Spring}>
          <a href="mailto:abdulmuhaiminmunu@gmail.com">
            <svg
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0)">
                <path
                  d="M52.4755 48.5012H3.514C1.60125 48.5012 0 46.9875 0 45.0327V11.158C0.00185244 10.2269 0.372783 9.33456 1.03148 8.67651C1.69019 8.01846 2.58292 7.64842 3.514 7.6475H52.4755C54.3882 7.6475 55.9895 9.2225 55.9895 11.1615V44.989C55.9457 46.991 54.3882 48.503 52.4755 48.503V48.5012Z"
                  fill="#F2F2F2"
                />
                <path
                  opacity="0.1"
                  d="M6.9999 48.5012L27.9474 33.1712L28.0804 32.2822L6.4749 16.7615L6.43115 47.7453L6.9999 48.5012Z"
                  fill="#221F1F"
                />
                <path
                  d="M3.51424 48.5012C1.57524 48.5012 0.000244141 46.9875 0.000244141 45.0327V11.1125C0.000244141 9.156 1.57524 8.8025 3.51424 8.8025C5.45324 8.8025 7.02824 9.205 7.02824 11.1125V48.4995L3.51424 48.5012Z"
                  fill="#D44C3D"
                />
                <path
                  d="M3.51411 9.3345C6.00436 9.3345 6.49436 10.0905 6.49436 11.1125V48.0095H3.51411C1.86911 48.0095 0.533857 46.676 0.533857 45.0293V11.1125C0.490107 10.0625 1.02386 9.3345 3.51411 9.3345ZM3.51411 8.8445C1.57511 8.84625 0.000107358 9.24525 0.000107358 11.1125V44.9855C-0.00649188 45.4488 0.0798929 45.9087 0.254151 46.338C0.42841 46.7673 0.687002 47.1573 1.01463 47.485C1.34226 47.8126 1.73227 48.0712 2.16159 48.2455C2.59091 48.4197 3.05082 48.5061 3.51411 48.4995H7.02811V11.1125C7.00011 9.2015 5.47061 8.84625 3.51411 8.84625V8.8445ZM52.4756 9.3345C54.7436 9.3345 55.4559 9.779 55.4559 11.025V45.0765C55.4559 46.7215 54.1224 48.0568 52.4756 48.0568H49.4954V11.025C49.4516 9.73525 50.2076 9.3345 52.4756 9.3345ZM52.4756 8.8445C50.5191 8.8445 48.9616 9.1105 48.9616 11.0232V48.5433H52.4756C54.4321 48.5433 55.9896 46.9683 55.9896 45.0293V10.9795C55.9459 9.06675 54.3884 8.8445 52.4756 8.8445Z"
                  fill="#D44C3D"
                />
                <path
                  d="M52.4757 48.5012H48.9617V11.025C48.9617 9.0685 50.5367 8.84624 52.4757 8.84624C54.4147 8.84624 55.9897 9.11225 55.9897 11.025V45.0765C55.9699 45.9941 55.5906 46.8672 54.9333 47.5078C54.276 48.1483 53.3935 48.5051 52.4757 48.5012Z"
                  fill="#D44C3D"
                />
                <path
                  opacity="0.08"
                  d="M37.4885 48.5013L0.311523 12.6L2.26802 13.3998L28.168 32.032L55.9878 11.6025V45.0765C55.986 45.5353 55.8935 45.9892 55.7157 46.4122C55.5379 46.8352 55.2782 47.2188 54.9517 47.5411C54.6252 47.8634 54.2382 48.1181 53.8129 48.2903C53.3877 48.4626 52.9326 48.5492 52.4738 48.545L37.4885 48.5013Z"
                  fill="#221F1F"
                />
                <path
                  d="M27.9302 33.215L1.51216 14.049C-0.0628352 12.894 -0.489835 10.6715 0.666915 9.114C1.82366 7.5565 4.04441 7.20125 5.64742 8.358L27.9722 24.5892L50.4299 8.1375C52.0049 6.9825 54.1662 7.33775 55.3212 8.93725C56.4762 10.5122 56.1209 12.6735 54.5214 13.8285L27.9302 33.215Z"
                  fill="#D44C3D"
                />
                <path
                  d="M52.4754 8.00171C53.4099 8.00171 54.3427 8.44621 54.9219 9.24771C55.8564 10.5812 55.5869 12.4502 54.2569 13.4477L27.9299 32.5945L1.82343 13.6507C0.489929 12.6707 0.132929 10.758 1.04993 9.45071C1.58368 8.65096 2.51993 8.16096 3.54018 8.16096C4.20518 8.16096 4.82993 8.33946 5.31818 8.73846L27.5957 24.926L27.9072 25.1045L28.2187 24.926L50.6537 8.48821C51.2312 8.17671 51.8087 7.99821 52.4772 7.99821L52.4754 8.00171ZM52.4754 7.46796C51.7632 7.46796 51.0054 7.64646 50.4279 8.13296L27.9719 24.5882L5.60343 8.31321C5.02593 7.86871 4.26993 7.64821 3.51393 7.64821C2.40268 7.69196 1.29143 8.18196 0.622929 9.11821C-0.488321 10.6932 -0.0420713 12.8545 1.51193 14.0095L27.9299 33.2157L54.5212 13.8257C55.2692 13.2781 55.7722 12.4586 55.9218 11.5437C56.0714 10.6288 55.8556 9.69178 55.3209 8.93446C54.6087 7.99996 53.5429 7.46446 52.4754 7.46446V7.46796Z"
                  fill="#D44C3D"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="56" height="56" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="https://www.facebook.com/munu.abdulmuhaimin" target={"_blank"} rel="noreferrer">
            <svg
              viewBox="0 0 58 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M43.5001 6.47727H36.2501C33.0454 6.47727 29.9719 7.72838 27.7059 9.95538C25.4398 12.1824 24.1668 15.2028 24.1668 18.3523V25.4773H16.9167V34.9773H24.1668V53.9773H33.8334V34.9773H41.0834L43.5001 25.4773H33.8334V18.3523C33.8334 17.7224 34.088 17.1183 34.5412 16.6729C34.9945 16.2275 35.6091 15.9773 36.2501 15.9773H43.5001V6.47727Z"
                stroke="#0081B1"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a href="https://www.instagram.com/abdulmuhaimin_1337" target={"_blank"} rel="noreferrer">
            <svg
              viewBox="0 0 57 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40.375 4.75001H16.625C10.0666 4.75001 4.75 10.0666 4.75 16.625V40.375C4.75 46.9334 10.0666 52.25 16.625 52.25H40.375C46.9334 52.25 52.25 46.9334 52.25 40.375V16.625C52.25 10.0666 46.9334 4.75001 40.375 4.75001Z"
                stroke="#FF0D2F"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M38 27.0037C38.2931 28.9803 37.9555 30.999 37.0352 32.7727C36.1149 34.5463 34.6588 35.9846 32.8739 36.883C31.089 37.7813 29.0663 38.094 27.0935 37.7766C25.1207 37.4591 23.2982 36.5277 21.8853 35.1148C20.4723 33.7018 19.5409 31.8793 19.2234 29.9065C18.906 27.9337 19.2187 25.911 20.1171 24.1261C21.0154 22.3413 22.4537 20.8851 24.2274 19.9648C26.001 19.0445 28.0197 18.7069 29.9963 19C32.0125 19.299 33.8791 20.2385 35.3203 21.6797C36.7616 23.121 37.7011 24.9876 38 27.0037Z"
                stroke="#FF0D2F"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M41.5625 15.4375H41.5884"
                stroke="#FF0D2F"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a href="https://www.linkedin.com/in/abdul-muhaimin-m3tah" target={"_blank"} rel="noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
          </a>
          <a href="https://github.com/m3tasploit" target={"_blank"} rel="noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000000"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
            </svg>
          </a>
          <a href="https://dribbble.com/m3tah" target={"_blank"} rel="noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff00c3"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>
            </svg>
          </a>
        </animated.div>
      </div>
      <animated.div className={classes.right} style={l5Spring}>
        <svg
          id="eed3bf71-60ac-4dd5-9baf-083416015b52"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 886.65322 655.0612"
          onMouseMove={({ clientX: x, clientY: y }) =>
            setBroSpring({ xy: calc(x, y) })
          }
          onMouseEnter={_ => {
            clearTimeout(broTimer.current.timer)
          }}
          onMouseLeave={_ => {
            broTimer.current.timer = setInterval(() => {
              let x = Math.floor(Math.random() * 50)
              let y = Math.floor(Math.random() * 100)
              setBroSpring({ xy: [x, y] })
            }, 500)
          }}
        >
          <animated.g
            id="browithphone"
            style={{ transform: broSpring.xy.interpolate(transBro) }}
          >
            <ellipse
              cx="728.74667"
              cy="636.31956"
              rx="144.42094"
              ry="18.74165"
              fill="#e6e6e6"
            />
            <path
              d="M893.38619,693.534s7.76033,26.73,12.93388,33.6281,9.48485,18.10744,6.89807,19.832-7.76033,22.41873-.86226,23.281,22.41873-22.41873,23.281-30.17906,4.3113-35.35262,4.3113-35.35262,6.03581-24.14325-3.449-25.86777-24.14325-2.58677-24.14325-2.58677Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#2f2e41"
            />
            <path
              d="M857.17131,721.98854s-11.20937,29.3168-13.79614,31.04132S831.30354,770.275,850.27324,770.275s29.3168-5.17355,29.3168-5.17355l6.03581-6.89807s0-18.10744-1.72451-20.69422,0-15.52066,0-15.52066Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#2f2e41"
            />
            <path
              d="M780.43026,453.826s-13.79614,93.124-1.72451,123.303S802.849,615.93069,802.849,615.93069l91.39944,85.36363s28.45455-14.6584,25.86777-24.14325c0,0-6.03581-3.449-6.89807-6.03581s-12.07162-3.449-12.07162-3.449-5.17356-6.03582-5.17356-9.48485S851.1355,593.512,836.4771,589.20066c0,0-7.76034-9.48485-6.89808-11.20936s-2.58677-7.76033-2.58677-7.76033l8.62259-33.6281,54.32231-8.62259s22.41873-79.32783,3.449-85.36364S780.43026,453.826,780.43026,453.826Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#2f2e41"
            />
            <path
              d="M888.21263,514.18413l1.72452,13.79615s0,36.21487-1.72452,39.66391-2.58678,8.62259,0,12.07162,6.89807,12.07163,5.17356,15.52066,3.449,100.8843-3.449,107.78237-4.3113,15.52066-3.449,16.38292-.86226,4.3113-.86226,4.3113-35.35261,6.03581-32.76583,0,2.58677-9.48485,4.31129-11.20937,0-4.31129,0-4.31129,2.58678-27.59229,0-29.31681S846.8242,594.37422,846.8242,593.512s-2.58677-2.58678-2.58677-6.03582,0-14.6584-4.3113-16.38292-3.449-43.9752-3.449-43.9752Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#2f2e41"
            />
            <path
              d="M826.99225,206.35769s3.449,25.86777,13.79614,31.04132,17.24518,7.76033,17.24518,7.76033L849.411,275.33841l-3.449,25.86777H806.298L784.74156,283.961l6.89807-28.45455,3.449-5.17355s4.31129-18.9697.86225-25.00551S826.99225,206.35769,826.99225,206.35769Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#ffb9b9"
            />
            <path
              d="M809.74707,269.30259l6.03581,11.20937s4.3113-15.52066,10.34711-18.10744,20.69421-6.89807,20.69421-10.3471-.86226-12.07163,2.58678-12.07163,37.07713,10.34711,42.25069,13.79614,6.03581,6.89807,6.03581,6.89807l-9.48485,99.15978s13.79614,46.562,9.48485,64.66942-7.76033,20.69422-18.10744,23.281-4.31129-6.03582-34.49036,2.58677-49.14876,6.03581-56.04683,6.03581-11.20936,3.449-12.93388,4.3113-.86226-4.3113,5.17355-12.07163,3.449-20.69421,3.449-20.69421-6.89807-22.41873-2.58678-31.04132,10.34711-19.832,5.17356-23.281-12.07163-29.31681-12.07163-29.31681l-18.9697-67.2562,38.80166-26.73s-1.72452,12.07162,4.31129,14.6584S809.74707,269.30259,809.74707,269.30259Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#00715e"
            />
            <path
              d="M761.46057,276.20067H756.287s-8.62259,14.6584-8.62259,25.00551,4.3113,68.98071,4.3113,68.98071l25.00551,25.86777,6.03581-19.832,1.72452-43.9752Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#00715e"
            />
            <path
              d="M775.25671,367.60011s-28.45454-7.76033-27.59229,4.3113,5.17356,26.73,18.9697,30.17906,18.10744-15.52066,18.10744-15.52066S786.46608,369.32463,775.25671,367.60011Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#00715e"
            />
            <path
              d="M882.17682,407.264s-1.72452,39.66391-12.07163,43.9752L895.1107,457.275s12.07163-41.38843,10.34711-43.11294S882.17682,407.264,882.17682,407.264Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#ffb9b9"
            />
            <path
              d="M742.84892,321.36239h16.15939a2.27559,2.27559,0,0,1,2.27559,2.27559v41.12367a2.77953,2.77953,0,0,1-2.77953,2.77953H743.35286a2.77953,2.77953,0,0,1-2.77953-2.77953V323.638A2.27559,2.27559,0,0,1,742.84892,321.36239Z"
              transform="translate(-231.76817 206.94387) rotate(-23.59797)"
              fill="#2f2e41"
            />
            <path
              d="M742.84892,321.36239h16.15939a2.27559,2.27559,0,0,1,2.27559,2.27559v41.12367a2.77953,2.77953,0,0,1-2.77953,2.77953H743.35286a2.77953,2.77953,0,0,1-2.77953-2.77953V323.638A2.27559,2.27559,0,0,1,742.84892,321.36239Z"
              transform="translate(-231.76817 206.94387) rotate(-23.59797)"
              opacity="0.1"
            />
            <path
              d="M743.35566,323.7882H757.444a2.27559,2.27559,0,0,1,2.27559,2.27559v39.02463a2.77953,2.77953,0,0,1-2.77953,2.77953H743.85959a2.77953,2.77953,0,0,1-2.77953-2.77953V326.06379a2.27559,2.27559,0,0,1,2.27559-2.27559Z"
              transform="translate(-232.36335 206.84727) rotate(-23.59797)"
              fill="#2f2e41"
            />
            <ellipse
              cx="745.31419"
              cy="339.85856"
              rx="4.14211"
              ry="4.19807"
              transform="translate(-230.39892 204.31202) rotate(-23.59795)"
              fill="#f2f2f2"
            />
            <path
              d="M888.64376,272.3205l5.60468-8.19146s20.69422,31.90358,18.9697,53.46006-3.449,22.41873-3.449,25.86776-4.3113,3.449,0,7.76033,10.3471,10.34711,6.89807,13.79615-6.03582,3.449-5.17356,7.76033a57.01221,57.01221,0,0,1,.86226,9.48485s-7.3292,14.22727-9.916,14.22727-27.16115,22.84986-27.16115,20.26308,2.58677-20.69421,2.58677-23.281.86226-11.20936,2.58678-13.79614,1.72452-1.72452,0-4.3113-1.72452,0-1.72452-2.58677.86226-6.03582-1.72451-6.89807-5.17356,0-3.449-4.3113,0-7.76033-.86226-7.76033-5.17355-.86226-2.58678-3.449-5.17355-52.59779-5.17355-52.59779S866.225,285.25438,888.64376,272.3205Z"
              transform="translate(-156.67339 -122.4694)"
              opacity="0.1"
            />
            <path
              d="M883.90134,253.78193l14.6584,6.89807s20.69421,31.90359,18.9697,53.46006-3.449,22.41873-3.449,25.86777-4.31129,3.449,0,7.76033,10.34711,10.34711,6.89807,13.79614-6.03581,3.449-5.17355,7.76033a57.01228,57.01228,0,0,1,.86226,9.48485s-7.76033,41.38843-10.34711,41.38843-26.73-4.3113-26.73-6.89807,2.58678-20.69422,2.58678-23.281.86226-11.20937,2.58678-13.79615,1.72451-1.72451,0-4.31129-1.72452,0-1.72452-2.58678.86226-6.03581-1.72452-6.89807-5.17355,0-3.449-4.31129,0-7.76034-.86225-7.76034-5.17356-.86225-2.58678-3.449-5.17355-52.5978-5.17355-52.5978S861.4826,266.71582,883.90134,253.78193Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#00715e"
            />
            <path
              d="M753.06237,373.7584a3.61426,3.61426,0,0,1-4.157-1.87589c-3.96236-7.92253-14.69832-31.1598-4.69-31.87468,9.233-.6595,17.45712,17.34444,20.8144,25.84817a4.10765,4.10765,0,0,1-2.77644,5.48373Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#ffb9b9"
            />
            <circle cx="646.17561" cy="76.12796" r="31.90358" fill="#ffb9b9" />
            <path
              d="M791.12583,180.2234a62.85212,62.85212,0,0,1-12.26475,2.8953c-3.14212.49024-6.8191.74125-9.02744-1.54708-2.16719-2.2457-1.81659-5.99168-.33836-8.74028s3.84626-4.90348,5.62269-7.46945c2.79389-4.03564,4.44281-9.38581,8.91037-11.41883a16.3903,16.3903,0,0,1,5.79859-1.08311c11.59287-.73911,23.65963-1.405,34.3956,3.03117a25.316,25.316,0,0,1,10.382,7.38693,27.56767,27.56767,0,0,1,4.14985,8.04652,52.51278,52.51278,0,0,1-9.44766,50.42489c-3.91263-3.52517-2.211-11.67073-7.16171-13.467-1.62421-.58931-3.46031-.17922-5.124-.64571-5.22862-1.4661-4.966-9.54653-9.31879-12.79321a8.31294,8.31294,0,0,1-2.47865-2.0369,5.06592,5.06592,0,0,1-.48223-2.56887c-.03182-3.0271,1.39012-10.71635-1.49749-12.79123C800.30454,175.33454,793.95018,179.2035,791.12583,180.2234Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#2f2e41"
            />
            <path
              d="M773.75827,702.74794s-2.34533-50.44293-50.42446-44.57962"
              transform="translate(-156.67339 -122.4694)"
              fill="#e6e6e6"
            />
            <path
              d="M976.48488,584.61844s2.34533-50.44293,50.42446-44.57962"
              transform="translate(-156.67339 -122.4694)"
              fill="#e6e6e6"
            />
            <path
              d="M975.49127,745.54612c-.06055-.53125-5.77149-53.42871,17.35254-81.42286,8.53418-10.332,19.96972-16.11816,33.98828-17.19628l.1543,1.99414c-13.45508,1.03515-24.42286,6.57714-32.59766,16.47168-22.583,27.335-16.96973,79.40429-16.91113,79.92675Z"
              transform="translate(-156.67339 -122.4694)"
              fill="#e6e6e6"
            />
            <rect
              x="615.30421"
              y="521.57379"
              width="2"
              height="110"
              fill="#e6e6e6"
            />
            <rect
              x="817.30421"
              y="410.57379"
              width="2"
              height="221"
              fill="#e6e6e6"
            />
            <circle cx="617.08488" cy="508.7277" r="16.41727" fill="#00715e" />
            <circle cx="819.81149" cy="395.28885" r="16.41727" fill="#00715e" />
            <circle cx="870.23596" cy="525.45432" r="16.41727" fill="#e6e6e6" />
          </animated.g>
          <animated.g
            id="message1"
            style={{ transform: broSpring.xy.interpolate(transMessage1) }}
          >
            <polygon
              points="386.652 0 0 0 0 126.931 14.646 126.931 14.646 160.129 47.843 126.931 386.652 126.931 386.652 0"
              fill="#e6e6e6"
            />
            <rect
              x="10.74034"
              y="12.36079"
              width="365.17167"
              height="101.54506"
              fill="#fff"
            />
            <rect
              x="43.03493"
              y="42.98392"
              width="175.8208"
              height="5.33572"
              fill="#00715e"
            />
            <rect
              x="43.03493"
              y="61.44186"
              width="306.44088"
              height="5.33572"
              fill="#e6e6e6"
            />
            <rect
              x="43.03493"
              y="79.8998"
              width="306.14082"
              height="5.33572"
              fill="#e6e6e6"
            />
          </animated.g>
          <animated.g
            id="message2"
            style={{ transform: broSpring.xy.interpolate(transMessage) }}
          >
            <polygon
              points="68.348 169.893 455 169.893 455 296.824 440.354 296.824 440.354 330.021 407.157 296.824 68.348 296.824 68.348 169.893"
              fill="#e6e6e6"
            />
            <rect
              x="79.08798"
              y="182.2535"
              width="365.17167"
              height="101.54506"
              fill="#fff"
            />
            <rect
              x="108.45338"
              y="211.90023"
              width="175.8208"
              height="5.33572"
              fill="#00715e"
            />
            <rect
              x="108.45338"
              y="230.35817"
              width="306.44088"
              height="5.33572"
              fill="#e6e6e6"
            />
            <rect
              x="108.45338"
              y="248.81611"
              width="306.14082"
              height="5.33572"
              fill="#e6e6e6"
            />
          </animated.g>
          <animated.g
            id="message3"
            style={{ transform: broSpring.xy.interpolate(transMessage1) }}
          >
            <polygon
              points="386.652 339.785 0 339.785 0 466.717 14.646 466.717 14.646 499.914 47.843 466.717 386.652 466.717 386.652 339.785"
              fill="#e6e6e6"
            />
            <rect
              x="10.74034"
              y="352.1462"
              width="365.17167"
              height="101.54506"
              fill="#fff"
            />
            <rect
              x="43.03493"
              y="382.76933"
              width="175.8208"
              height="5.33572"
              fill="#00715e"
            />
            <rect
              x="43.03493"
              y="401.22727"
              width="306.44088"
              height="5.33572"
              fill="#e6e6e6"
            />
            <rect
              x="43.03493"
              y="419.68521"
              width="306.14082"
              height="5.33572"
              fill="#e6e6e6"
            />
          </animated.g>
        </svg>
      </animated.div>
    </div>
  )
}

export default Contact
